import HomeIcon from "@mui/icons-material/Home";

export const getCompanyDetailsNavList = (companyDetails) => {
  if (!companyDetails) return [];
  return [
    {
      label: "Home",
      value: "home",
      icon: <HomeIcon />,
      route: "/feature-selection/",
    },
    {
      label: "Company List",
      value: "companyList",
      route: "/companiesview",
    },
    ...(companyDetails && [
      {
        label: companyDetails?.companyName,
        value: "details",
        route: `/companiesview/${companyDetails?.id}/details`,
      },
    ]),
  ];
};

// export const getDefaultCompanyDetails = (data) => ({ ...data });
// company-details.utils.js
export const getDefaultCompanyDetails = (data) => ({
  companyName: data?.companyName || "",
  companyID: data?.companyID || "",
  dateCreated: data?.dateCreated || "",
  createdBy: data?.createdBy || "",
  type: data?.type || "",
  rateCard: data?.rateCard || "",
  companyState: data?.companyState || "",
  streetAddress: data?.streetAddress || "",
  address: data?.address || "",
  city: data?.city || "",
  province: data?.province || "",
  postalCode: data?.postalCode || "",
  country: data?.country || "Canada",
  webAddress: data?.webAddress || "",
  phoneNumber: data?.phoneNumber || "",
  companyNotes: data?.companyNotes || "",
  isNotBilling: data?.isNotBilling ?? true,
  billingStreetAddress: data?.billingStreetAddress || "",
  billingAddress: data?.billingAddress || "",
  billingCity: data?.billingCity || "",
  billingProvince: data?.billingProvince || "",
  billingPostalCode: data?.billingPostalCode || "",
  billingCountry: data?.billingCountry || "",
});

export const COMPANY_DETAILS_TAB_LIST = [
  { label: "Basic Info", value: "basic-info" },
  { label: "Linked Projects", value: "linked-projects" },
];
